var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:`cancellation-policy-${_vm.currentRoomStay.cancellationConditions}`},[_vm._v(_vm._s(_vm.cancelPenalties)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }